import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import {
  DeleteFavoriteProductsRequest,
  DeleteFavoriteProductsResponse,
} from 'src/types/favorite';
import axiosInstance from 'src/utils/axios';

export async function deleteFavoriteProducts(
  request: DeleteFavoriteProductsRequest
): Promise<DeleteFavoriteProductsResponse> {
  const res = await axiosInstance.delete<DeleteFavoriteProductsResponse>(
    api.deleteFavoriteProducts,
    { data: request }
  );
  return res.data;
}

const useDeleteFavoriteProductsMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: DeleteFavoriteProductsResponse) => void;
  onError?: (error: Error) => void;
} = {}) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: queryKeys.favorite.deleteFavoriteProducts(),
    mutationFn: deleteFavoriteProducts,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.favorite.root });
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error as Error);
    },
  });

  return mutation;
};

export default useDeleteFavoriteProductsMutation;
